<template>
  <template v-if="doneLoading">
    <header-component :impersonating />
    <slot></slot>
  </template>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import HeaderComponent from "@/courses/components/navigation/HeaderComponent.vue";

export default {
  name: "BaseComponent",
  components: {
    HeaderComponent,
  },
  props: {
    courseId: {
      type: String,
      required: false,
      default: null,
    },
    impersonating: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      doneLoading: false,
    };
  },
  methods: {
    ...mapActions(["getCurrentUser"]),
    ...mapActions("course", ["getHeaderData", "getCurrentCourse"]),
    ...mapMutations("course", ["setCourseId"]),
  },
  created() {
    if (this.courseId) {
      Promise.allSettled([
        this.getCurrentUser(),
        this.setCourseId(this.courseId),
        this.getHeaderData(this.courseId),
        this.getCurrentCourse(this.courseId),
      ]).then(() => {
        this.doneLoading = true;
      });
    } else {
      this.getCurrentUser().then(() => (this.doneLoading = true));
    }
  },
};
</script>
